import {
    Center,
    TableContainer,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Table,
    Grid,
    Heading,
    Button,
    Input,
    Select,
    HStack,
    Badge,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux/storage';
import { fetchPayments, filterPayments } from '../../redux/features/paymentListSlice';
import LoadingPage from '../LoadingPage';
import { useNavigate } from 'react-router-dom';
import { PaymentStatus } from '../../utils/const';
import moment from 'moment';
import { PagingControls } from '../../components/pagination/Pagination';
import MenuNavbar from '../../components/ui/Menu';
import usePageTitle from '../../utils/pageTitle';

const PaymentList = () => {

    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const payments = useSelector((state: any) => state.paymentList)
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(25)
    const [filter, setFilter] = useState({
        reference: '',
        user: '',
        bank: '',
        status: ''
    })

    usePageTitle("Lista Pagos")

    useEffect(() => {
        dispatch(fetchPayments())
    }, [])


    const handleSubmit = (event: any) => {

        event.preventDefault()

        setCurrentPage(1)

        dispatch(filterPayments(filter))
    }

    const handleChange = (event: { target: HTMLInputElement | HTMLSelectElement }) => {

        setFilter({ ...filter, [event.target.name]: event.target.value })
    }

    return (
        <Grid minHeight="100vh">

            <MenuNavbar />
            
            <Center>

                {payments.loading ? <LoadingPage /> :
                    <TableContainer>
                        <Heading size='md' mb={5}>
                            <Center>
                                Listado de pagos
                            </Center>
                        </Heading>

                        <Button colorScheme="brand" variant='solid' onClick={() => navigate('/payment/verify')}>
                            Confirmar pagos
                        </Button>


                        <form onSubmit={handleSubmit}>

                            <HStack spacing={1} mt={5} mb={5} w='100%'>
                                <Input variant='filled' name="reference" placeholder='Referencia' onChange={handleChange} defaultValue={filter.reference} />

                                <Select variant='filled' name="bank" onChange={handleChange} defaultValue={filter.bank}>
                                    <option value='' key={0}>-- Banco --</option>
                                    {
                                        payments.banks.map((b: any) => <option key={b.id}>{b.name}</option>)
                                    }
                                </Select>
                                <Select variant='filled' name="status" onChange={handleChange} defaultValue={filter.status}>
                                    <option value='' key={0}>-- Estado --</option>
                                    {
                                        payments.status.map((s: any) => <option key={s}>{s}</option>)
                                    }
                                </Select>
                                <Select variant='filled' name="user" onChange={handleChange} defaultValue={filter.user}>
                                    <option value='' key={0}>-- Usuario --</option>
                                    {
                                        payments.users.map((u: any) => <option key={u.id}>{u.name}</option>)
                                    }
                                </Select>

                                <Button type='submit' colorScheme="brand" variant='solid' minWidth={100}>
                                    Buscar
                                </Button>
                            </HStack>
                        </form>

                        <Table variant='simple'>
                            <Thead>
                                <Tr>
                                    <Th>Fecha consulta</Th>
                                    <Th>Banco Receptor</Th>
                                    <Th>Banco Emisor</Th>
                                    <Th>Referencia</Th>
                                    <Th>Monto</Th>
                                    <Th>Estado</Th>
                                    <Th>Consultor</Th>
                                </Tr>
                            </Thead>

                            <Tbody>

                                {
                                    !payments.loading && payments.payments.length > 0 ?

                                        payments.payments.slice((currentPage - 1) * pageSize, (currentPage) * pageSize).map((p: any) =>
                                            <Tr key={p.id}>
                                                <Td>{moment(p.createdAt).format('DD/MM/YYYY h:mm:ss')}</Td>
                                                <Td>{p.bank.name}</Td>
                                                <Td>{p.issuingBank.name}</Td>
                                                <Td>{p.reference}</Td>
                                                <Td>{p.amount}</Td>
                                                <Td>
                                                    <Badge colorScheme={p.status === PaymentStatus.Success ? 'green' : 'red'}>
                                                        {p.status}
                                                    </Badge>
                                                </Td>
                                                <Td>{p.user.name}</Td>
                                            </Tr>)
                                        :
                                        <Tr>
                                            <Td>No se encontraron resultados</Td>
                                        </Tr>
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                }
            </Center>
            <PagingControls
                currentPage={currentPage}
                onGoToPage={(newPageNumber) =>  setCurrentPage(newPageNumber)}
                pageSize={pageSize}
                totalCount={payments.payments.length}
                totalCountDescription={"Resultados"}
            />
        </Grid >
    );
}


export default PaymentList;
